/**
 * 任務補登（Mission Amendment）— LINE@ 端型別。
 *
 * 對應後端 `com.towconnect.api.application.dispatch.dto.*`。
 */

export type AmendmentMode =
  | 'DIRECT_WEB'
  | 'ASSIGN_TO_DRIVER'
  | 'SELF_LINEAT'
  | 'COMPLETE_ASSIGNED'
  | 'FROM_TASK_Q'

export type AmendmentStatus =
  | 'PENDING_FILL'
  | 'PENDING_REVIEW'
  | 'APPROVED'
  | 'REJECTED'
  | 'RETURNED'   // v2.3：退回重填（PENDING_REVIEW → RETURNED → PENDING_REVIEW）

export interface MissionAmendment {
  id: string
  amendmentMode: AmendmentMode
  status: AmendmentStatus
  sourceTaskQId: string | null
  sourceTaskQId2: string | null
  targetMissionId: string | null
  targetMissionId2: string | null
  driverId: string
  driverName: string | null
  dailyReportId: string | null
  dailyReportDate: string | null
  trailerCoCd: string
  trailerNo: string | null
  /** v2 #5：拖運日期（YYYY-MM-DD），對應 mission.duty_date */
  dutyDate: string | null
  vesselRegNo: string
  /** v2.3：補登用船名 fallback */
  amendmentVslName: string | null
  containerNo: string
  containerSize: string
  emptyLaden: string
  ioType: string
  containerWeight: number | null
  doubleTowFlag: boolean
  containerNo2: string | null
  containerWeight2: number | null
  originLocation: string
  originLocationShortName: string | null
  originLocationAreaCode: string | null
  destinationLocation: string
  destinationLocationShortName: string | null
  destinationLocationAreaCode: string | null
  billingRequester: string
  billingRequesterName: string | null
  rejectReason: string | null
  createdBy: string
  createdByName: string | null
  createdAt: string
  reviewedBy: string | null
  reviewedByName: string | null
  reviewedAt: string | null
  updatedAt: string
}

export interface CreateOneShotAmendmentRequest {
  mode: AmendmentMode
  driverId: string
  // v2 #5：dailyReportId / dutyDate 至少其一
  dailyReportId?: string | null
  trailerCoCd: string
  trailerNo: string
  dutyDate?: string | null
  vesselRegNo: string
  /** v2.3：補登用船名 fallback */
  amendmentVslName?: string | null
  containerNo: string
  containerSize: string
  emptyLaden: string
  ioType: string
  containerWeight?: number | null
  originLocation: string
  destinationLocation: string
  billingRequester: string
  doubleTowFlag: boolean
  containerNo2?: string | null
  containerWeight2?: number | null
  sourceTaskQId?: string | null
  sourceTaskQId2?: string | null
}

export interface CompleteAssignedShellRequest {
  // v2 #5：dailyReportId / dutyDate 至少其一
  dailyReportId?: string | null
  trailerNo: string
  dutyDate?: string | null
  containerWeight?: number | null
  doubleTowFlag: boolean
  containerNo2?: string | null
  containerWeight2?: number | null
  sourceTaskQId2?: string | null
}

export interface DailyReportListItem {
  dailyReportId: string
  driverId: string
  driverName: string | null
  vehicleNo: string
  reportDate: string
  clockInTime: string | null
  reportStatus: 'O' | 'C' | string
  companyCd: string
}

export interface TaskQItem {
  id: string
  queueType: string
  queueStatus: string
  vesselRegNo: string | null
  containerNo: string | null
  ioType: string | null
  containerSize: string | null
  emptyLaden: string | null
  containerWeight: number | null
  originLocation: string | null
  originLocationShortName: string | null
  originLocationAreaCode: string | null
  destinationLocation: string | null
  destinationLocationShortName: string | null
  destinationLocationAreaCode: string | null
  trailerNo: string | null
  operationDate: string | null
  operationTime: string | null
  createdAt: string
  linkedAmendmentStatus: AmendmentStatus | null
}

export const AMENDMENT_STATUS_LABEL: Record<AmendmentStatus, string> = {
  PENDING_FILL: '待填寫',
  PENDING_REVIEW: '待審核',
  APPROVED: '已補登',
  REJECTED: '已退件',
  RETURNED: '退回重填',
}

export const AMENDMENT_MODE_LABEL: Record<AmendmentMode, string> = {
  DIRECT_WEB: 'WEB 直接補登',
  ASSIGN_TO_DRIVER: '被指派補登',
  SELF_LINEAT: '自發補登',
  COMPLETE_ASSIGNED: '完成指派',
  FROM_TASK_Q: '佇列補登',
}
